import {
  FiltersNames,
  type FiltersParams,
} from '@/features/listing/types/listing-filters-types';

export default function getListingsFiltersParams(searchParams: URLSearchParams): Partial<FiltersParams> {
  const listingFiltersSearchParams: Partial<FiltersParams> = {};
  const filtersNames = Object.values(FiltersNames);

  // Need to filter out any invalid search params that not applicable to listings
  searchParams.forEach((value, key) => {
    // @ts-expect-error - TS doesn't know that key is a valid SearchParams key
    if (value && filtersNames.includes(key)) {
      // @ts-expect-error - TS doesn't know that key is a valid SearchParams key
      listingFiltersSearchParams[key] = value;
    }
  });

  return listingFiltersSearchParams;
}
